<template>
    <accordion-item>
        <h2 slot="header">
            Dependency on Services &mdash; {{currencyFormat(value)}}
        </h2>
        <p>
            This head of loss is determined (i) from the deceased's date of death to the deceased's 'but for' date
            of death, and (ii) either applying a multiplicand based on average data within the tool for claims of a
            similar type, or a multiplicand of £1,500. The period between death and assumed date of trial/settlement 
            is discounted by Table E Factor. The multiplier is applied from date of trial/assumed settlement but discounted by Table F Factor.
        </p>
    </accordion-item>
</template>

<script>
    import AccordionItem from "components/accordion/AccordionItem";
    import currencyFormat from 'mixins/currencyFormat';

    export default {
        name: "dependency-services-modal",
        components: {
            AccordionItem
        },
        mixins:[
            currencyFormat
        ],
        props: {
            value: {
                required: true
            }
        }
    }
</script>


// WEBPACK FOOTER //
// DependencyServicesModal.vue?18d6d04e